import { computeEvaluation } from "./scoringEval";

// wais-scoring.js uses CommonJS exports — webpack handles the interop
import { scoreWAIS_ATT_MDT } from "db/WAIS-ATT-MDT/wais-scoring";
import { scoreSubtest_DE } from "db/WAIS-IV-DE/wais-iv-de-scoring";

function scoreSubtest(subtestKey, resultLoc, rawScore, age, expectedNormSource) {
  const result = scoreWAIS_ATT_MDT(age, { [subtestKey]: rawScore }, subtestKey);
  if (result.error) return { error: result.error };
  const sub = result.subtests[subtestKey];
  if (!sub) return { error: "Aucun résultat" };
  if (sub.error) return { error: sub.error };
  const resultData = [{ name: "nS", label: "NS", value: sub.ns }];
  const resultText = `NS= ${sub.ns}`;
  const evaluation = computeEvaluation(resultData, resultLoc);
  const warning = expectedNormSource && result.normSource !== expectedNormSource
    ? `Âge ${age} ans : en dehors de la plage normative WAIS-IV (16–79 ans)`
    : null;
  return { resultLoc, resultData, resultText, evaluation, warning };
}

// German WAIS-IV uses its own norm tables (Tabelle A.1) via the per-subtest
// parquets, which differ from the French WAIS-ATT-MDT norms.
async function scoreSubtestDE(subtestKey, resultLoc, rawScore, age) {
  const sub = await scoreSubtest_DE(subtestKey, rawScore, age);
  if (sub.error) return { error: sub.error };
  const resultData = [{ name: "nS", label: "NS", value: sub.wp }];
  const resultText = `NS= ${sub.wp}`;
  const evaluation = computeEvaluation(resultData, resultLoc);
  return { resultLoc, resultData, resultText, evaluation };
}

export function calcWAISCodeScore(rawScore, age, lang) {
  if (lang === "de") return scoreSubtestDE("zst", "G18", rawScore, age);
  return scoreSubtest("cod", "G18", rawScore, age, "WAIS-IV");
}

export function calcWAISCodeIIIScore(rawScore, age) {
  return scoreSubtest("cod", "G19", rawScore, age);
}

export function calcWAISSymScore(rawScore, age, lang) {
  if (lang === "de") return scoreSubtestDE("sys", "G16", rawScore, age);
  return scoreSubtest("sym", "G16", rawScore, age, "WAIS-IV");
}

export function calcWAISSymIIIScore(rawScore, age) {
  return scoreSubtest("sym", "G17", rawScore, age);
}
